import {
    get,
    isEqual
} from 'lodash';
import { saveToSessionStorage, loadFromSessionStorage } from '../../utils/sessionStorage';
import {
    generatePayoutAccountIdsString,
    TOGGLE_SELECTOR_OPEN,
    UPDATE_SELECTED_PAYOUT_ACCOUNTS
} from './payoutAccountSelectorActions';
import { PAYOUT_ACCOUNTS_SUCCESS } from '../PayoutAccounts/payoutAccountActions';
import { createSelector } from 'reselect';
import { getViewStateByName } from '../appViewStates';

const sessionStorageSelectedPayoutAccountsKey = 'emvio-selected-payout-accounts';
const sessionStorageAllPayoutAccountsSelectedKey = 'emvio-all-payout-accounts-selected';

export default function reducer(state = {
    selectedPayoutAccounts: []
}, action = {}) {
    let newState;

    switch (action.type) {
        case PAYOUT_ACCOUNTS_SUCCESS: {
            const storedSelectedPayoutAccounts = loadFromSessionStorage(sessionStorageSelectedPayoutAccountsKey);
            const isAllSelected = loadFromSessionStorage(sessionStorageAllPayoutAccountsSelectedKey);
            let selectedPayoutAccounts = action.payoutAccounts.slice(0);

            if (!isAllSelected && storedSelectedPayoutAccounts) {
                selectedPayoutAccounts = action.payoutAccounts.filter((payoutAccount) => {
                    return storedSelectedPayoutAccounts.includes(payoutAccount.payoutAccountId);
                });
            }

            newState = {
                ...state,
                selectedPayoutAccounts
            };

            return isEqual(state, newState) ? state : newState;
        }

        case TOGGLE_SELECTOR_OPEN:
            newState = {
                ...state,
                isOpen: !state.isOpen
            };

            return isEqual(state, newState) ? state : newState;

        case UPDATE_SELECTED_PAYOUT_ACCOUNTS:
            saveToSessionStorage(sessionStorageSelectedPayoutAccountsKey, action.payoutAccounts.map((payoutAccount) => payoutAccount.payoutAccountId));
            saveToSessionStorage(sessionStorageAllPayoutAccountsSelectedKey, action.isAllSelected);

            newState = {
                ...state,
                selectedPayoutAccounts: action.payoutAccounts
            };

            return isEqual(state, newState) ? state : newState;

        default:
            return state;
    }
}

export const getPayoutAccountSelectorViewState = createSelector(
    (state) => state,
    (state) => getViewStateByName(state, 'payoutAccountSelector')
);

export const getSelectedPayoutAccounts = createSelector(
    getPayoutAccountSelectorViewState,
    (viewState) => get(viewState, 'selectedPayoutAccounts')
);

export const getSelectedPayoutAccountIdsString = createSelector(
    getSelectedPayoutAccounts,
    (payoutAccountsArray = []) => generatePayoutAccountIdsString(payoutAccountsArray)
);

export const getIsSelectorOpen = createSelector(
    getPayoutAccountSelectorViewState,
    (viewState) => get(viewState, 'isOpen')
);

export const getDoAnySelectedPayoutAccountsHaveFraud = createSelector(
    getSelectedPayoutAccounts,
    (payoutAccounts = []) => payoutAccounts.some((payoutAccount) => payoutAccount.kountMerc)
);
